module.exports = __webpack_public_path__ + "img/vascular-250.aaf4ca68.jpg";